import { siteInfo, navLinks } from '@/mocks/home-data';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-md text-sm font-bold">
                爆
              </span>
              <span className="text-lg font-heading text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-xs leading-relaxed text-background-50/60">
              爆料吃瓜网 — 国内领先的娱乐八卦信息聚合平台。每日滚动更新最新爆料与今日吃瓜实时瓜料，覆盖影视综艺、明星动态、网红圈层及泛娱乐领域，为吃瓜群众提供一站式八卦追踪体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a
                href="#hero"
                onClick={(e) => handleNavClick(e, '#hero')}
                className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
              >
                首页
              </a>
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-50/40 leading-relaxed">
              诚邀各大娱乐媒体、自媒体平台及品牌方合作，共同打造更丰富的八卦内容生态。合作洽谈请通过投稿合作通道联系我们。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-4">关注我们</h4>
            <div className="flex items-center gap-3 mb-4">
              <a href="#contact" className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
            <p className="text-xs text-background-50/40">
              投稿邮箱：tips@baguachigua.com
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span>用户协议</span>
            <span>隐私政策</span>
            <span>免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}